import { useTranslation } from 'react-i18next'

import { PageHeader } from 'components/Header'
import { InvoiceDetailsSection } from './sections/InvoiceDetailsSection'
import { MonthlyEarningsSection } from './sections/MonthlyEarningsSection'

export const FinancePage = (): React.JSX.Element => {
  const { t } = useTranslation('features/finance')

  return (
    <>
      <PageHeader title={t('header')} />
      <InvoiceDetailsSection />
      <MonthlyEarningsSection />
    </>
  )
}
